import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Allergen = {
  __typename: 'Allergen';
  allergenTypeCode: Maybe<Scalars['String']>;
  allergenTypeText: Maybe<Scalars['String']>;
  levelOfContainmentCode: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Coordinates = {
  __typename: 'Coordinates';
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export type CoordinatesInput = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type Country = {
  __typename: 'Country';
  code: Scalars['String'];
};

export type CountryName = {
  __typename: 'CountryName';
  fi: Maybe<Scalars['String']>;
};

export type CreateProductResolvedShoppingListItemInput = {
  collected?: InputMaybe<Scalars['Boolean']>;
  commentForPicker?: InputMaybe<Scalars['String']>;
  ean: Scalars['String'];
  isReplaceable: Scalars['Boolean'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  quantityUnit: Scalars['String'];
  sokId: Scalars['String'];
};

export type CreateShoppingListItemInput = {
  collected?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export enum DayLabel {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum Domain {
  Abc = 'ABC',
  Eprisma = 'EPRISMA',
  Herkku = 'HERKKU',
  SKaupat = 'S_KAUPAT'
}

export type HierarchyPathItem = {
  __typename: 'HierarchyPathItem';
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type IdObject = {
  __typename: 'IDObject';
  id: Scalars['ID'];
};

export type IShoppingListItem = {
  collected: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shoppingListId: Scalars['String'];
};

export type InsertByEanInput = {
  ean: Scalars['String'];
  quantity: Scalars['Float'];
};

export type LocalizableText = {
  __typename: 'LocalizableText';
  default: Scalars['String'];
  en: Maybe<Scalars['String']>;
  et: Maybe<Scalars['String']>;
  fi: Maybe<Scalars['String']>;
  sv: Maybe<Scalars['String']>;
};

export type LocalizedText = {
  __typename: 'LocalizedText';
  en: Maybe<Scalars['String']>;
  et: Maybe<Scalars['String']>;
  fi: Maybe<Scalars['String']>;
  sv: Maybe<Scalars['String']>;
};

export type Municipality = {
  __typename: 'Municipality';
  code: Scalars['String'];
  name: Maybe<LocalizableText>;
};

export type Mutation = {
  __typename: 'Mutation';
  batchDeleteShoppingListItem: ShoppingList;
  batchInsertByEan: ShoppingList;
  batchInsertShoppingListItem: ShoppingList;
  batchUpdateShoppingListItem: ShoppingList;
  claimSharedShoppingList: ShoppingList;
  createProductResolvedShoppingListItem: ShoppingList;
  createShoppingList: Maybe<ShoppingList>;
  createShoppingListFromRecipe: Maybe<ShoppingList>;
  createShoppingListItem: ShoppingList;
  deleteShoppingList: IdObject;
  deleteShoppingListItem: ShoppingList;
  duplicateShoppingList: ShoppingList;
  generateShoppingListShareLink: SharedShoppingListLink;
  insertRecipeProductsToList: ShoppingList;
  resolveShoppingListItemProduct: ShoppingList;
  setListItemsReplaceability: ShoppingList;
  unresolveShoppingListItemProduct: ShoppingList;
  updateShoppingList: ShoppingList;
  updateShoppingListItem: ProductResolvedShoppingListItem | ShoppingListItem;
};


export type MutationBatchDeleteShoppingListItemArgs = {
  ids: Array<Scalars['ID']>;
  shoppingListId: Scalars['ID'];
};


export type MutationBatchInsertByEanArgs = {
  items: Array<InsertByEanInput>;
  shoppingListId: Scalars['ID'];
};


export type MutationBatchInsertShoppingListItemArgs = {
  items: InputMaybe<Array<CreateShoppingListItemInput>>;
  productResolvedItems: InputMaybe<Array<CreateProductResolvedShoppingListItemInput>>;
  shoppingListId: Scalars['ID'];
};


export type MutationBatchUpdateShoppingListItemArgs = {
  ids: Array<Scalars['ID']>;
  items: Array<UpdateShoppingListItemInput>;
  shoppingListId: Scalars['ID'];
};


export type MutationClaimSharedShoppingListArgs = {
  linkId: Scalars['ID'];
};


export type MutationCreateProductResolvedShoppingListItemArgs = {
  item: CreateProductResolvedShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};


export type MutationCreateShoppingListArgs = {
  items: InputMaybe<Array<CreateShoppingListItemInput>>;
  name: Scalars['String'];
  productResolvedItems: InputMaybe<Array<CreateProductResolvedShoppingListItemInput>>;
  storeId: InputMaybe<Scalars['String']>;
};


export type MutationCreateShoppingListFromRecipeArgs = {
  name: Scalars['String'];
  recipeId: Scalars['String'];
  storeId: InputMaybe<Scalars['String']>;
};


export type MutationCreateShoppingListItemArgs = {
  item: CreateShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};


export type MutationDeleteShoppingListArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShoppingListItemArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
};


export type MutationDuplicateShoppingListArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
  storeId: InputMaybe<Scalars['String']>;
};


export type MutationGenerateShoppingListShareLinkArgs = {
  id: Scalars['ID'];
  permissions: Array<Permission>;
  validForHours: InputMaybe<Scalars['Int']>;
};


export type MutationInsertRecipeProductsToListArgs = {
  recipeId: Scalars['String'];
  shoppingListId: Scalars['ID'];
};


export type MutationResolveShoppingListItemProductArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
  sokId: Scalars['String'];
};


export type MutationSetListItemsReplaceabilityArgs = {
  isReplaceable: Scalars['Boolean'];
  shoppingListId: Scalars['ID'];
};


export type MutationUnresolveShoppingListItemProductArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
};


export type MutationUpdateShoppingListArgs = {
  id: Scalars['ID'];
  name: InputMaybe<Scalars['String']>;
  storeId: InputMaybe<Scalars['String']>;
};


export type MutationUpdateShoppingListItemArgs = {
  id: Scalars['ID'];
  item: UpdateShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};

export type Navigation = {
  __typename: 'Navigation';
  navigation: Maybe<Array<NavigationItem>>;
};

export type NavigationItem = {
  __typename: 'NavigationItem';
  children: Maybe<Array<NavigationItem>>;
  hidden: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  itemCount: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  sequence: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type Nutrient = {
  __typename: 'Nutrient';
  kcal: Maybe<Scalars['Float']>;
  kj: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  ri: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum PaymentMethod {
  CardPayment = 'CARD_PAYMENT',
  Invoice = 'INVOICE',
  OnDelivery = 'ON_DELIVERY'
}

export enum Permission {
  Read = 'READ',
  Share = 'SHARE',
  Write = 'WRITE'
}

export type Product = {
  __typename: 'Product';
  _lemmasAliasName: Maybe<Scalars['String']>;
  _lemmasDescription: Maybe<Scalars['String']>;
  _lemmasHierarchyLeaf: Maybe<Scalars['String']>;
  _lemmasName: Maybe<Scalars['String']>;
  allergens: Maybe<Array<Allergen>>;
  approxPrice: Maybe<Scalars['Boolean']>;
  available: Scalars['Boolean'];
  basicQuantityUnit: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  comparisonPrice: Maybe<Scalars['Float']>;
  comparisonUnit: Maybe<Scalars['String']>;
  countryName: Maybe<CountryName>;
  depositPrice: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  ean: Scalars['String'];
  frozen: Maybe<Scalars['Boolean']>;
  hierarchyPath: Maybe<Array<HierarchyPathItem>>;
  id: Scalars['ID'];
  ingredientStatement: Maybe<Scalars['String']>;
  isAgeLimitedByAlcohol: Maybe<Scalars['Boolean']>;
  isGlobalFallback: Maybe<Scalars['Boolean']>;
  location: Maybe<ProductLocation>;
  measurement: Maybe<ProductMeasurement>;
  name: Scalars['String'];
  nutrients: Maybe<Array<Nutrient>>;
  packagingLabelCodes: Maybe<Array<Scalars['String']>>;
  packagingLabels: Maybe<Array<Scalars['String']>>;
  price: Maybe<Scalars['Float']>;
  priceUnit: Scalars['String'];
  pricing: Maybe<ProductPricing>;
  quantityMultiplier: Maybe<Scalars['Float']>;
  storeId: Maybe<Scalars['ID']>;
  storeInfo: Maybe<Array<StoreInfo>>;
  supplierName: Maybe<Scalars['String']>;
};


export type ProductStoreInfoArgs = {
  pageSize: InputMaybe<Scalars['Int']>;
  userLocation: InputMaybe<CoordinatesInput>;
};

export enum ProductDataSource {
  SKaupat = 'S_KAUPAT',
  SOstoslista = 'S_OSTOSLISTA'
}

export type ProductLocation = {
  __typename: 'ProductLocation';
  aisle: Maybe<Scalars['String']>;
  floor: Scalars['Int'];
  label: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type ProductMeasurement = {
  __typename: 'ProductMeasurement';
  grossWeight: Maybe<Scalars['Float']>;
  grossWeightUnit: Maybe<Scalars['String']>;
  netWeight: Maybe<Scalars['Float']>;
  netWeightUnit: Maybe<Scalars['String']>;
  pceApproxWeight: Maybe<Scalars['Float']>;
};

export type ProductPricing = {
  __typename: 'ProductPricing';
  campaignPrice: Maybe<Scalars['Float']>;
  campaignPriceValidUntil: Maybe<Scalars['String']>;
  comparisonPrice: Scalars['Float'];
  currentPrice: Scalars['Float'];
  depositPrice: Maybe<Scalars['Float']>;
  lowest30DayPrice: Maybe<Scalars['Float']>;
  regularPrice: Scalars['Float'];
};

export type ProductResolvedShoppingListItem = IShoppingListItem & {
  __typename: 'ProductResolvedShoppingListItem';
  collected: Maybe<Scalars['Boolean']>;
  commentForPicker: Maybe<Scalars['String']>;
  ean: Scalars['String'];
  id: Scalars['ID'];
  isReplaceable: Scalars['Boolean'];
  name: Scalars['String'];
  product: Maybe<Product>;
  quantity: Scalars['Float'];
  quantityUnit: Scalars['String'];
  shoppingListId: Scalars['String'];
  sokId: Scalars['String'];
};


export type ProductResolvedShoppingListItemProductArgs = {
  dataSource: InputMaybe<ProductDataSource>;
  storeId: InputMaybe<Scalars['String']>;
};

export type ProductSearchResult = {
  __typename: 'ProductSearchResult';
  items: Array<Product>;
  maybeHasMore: Scalars['Boolean'];
};

export type Query = {
  __typename: 'Query';
  anonymousUserToken: Scalars['String'];
  navigation: Maybe<Array<NavigationItem>>;
  product: Product;
  productByEan: Product;
  products: ProductSearchResult;
  recipes: SearchRecipesResponse;
  shoppingList: ShoppingList;
  shoppingLists: Array<ShoppingList>;
  store: StoreInfo;
  stores: SearchStoresResponse;
  user: Maybe<User>;
};


export type QueryNavigationArgs = {
  storeId: Scalars['ID'];
};


export type QueryProductArgs = {
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  storeId: InputMaybe<Scalars['ID']>;
};


export type QueryProductByEanArgs = {
  ean: Scalars['ID'];
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  storeId: InputMaybe<Scalars['ID']>;
};


export type QueryProductsArgs = {
  eans: InputMaybe<Array<Scalars['String']>>;
  excludedCdts: InputMaybe<Array<Scalars['String']>>;
  from: InputMaybe<Scalars['Int']>;
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  ids: InputMaybe<Array<Scalars['ID']>>;
  includedCdts: InputMaybe<Array<Scalars['String']>>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  storeId: InputMaybe<Scalars['ID']>;
};


export type QueryRecipesArgs = {
  from: InputMaybe<Scalars['Int']>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryShoppingListArgs = {
  id: Scalars['ID'];
};


export type QueryStoreArgs = {
  id: Scalars['ID'];
};


export type QueryStoresArgs = {
  brand: InputMaybe<StoreBrand>;
  cursor: InputMaybe<Scalars['String']>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};

export type Recipe = {
  __typename: 'Recipe';
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  notes: Maybe<Array<RecipeNote>>;
  products: Array<RecipeProduct>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type RecipeNote = {
  __typename: 'RecipeNote';
  content: Scalars['String'];
};

export type RecipeProduct = {
  __typename: 'RecipeProduct';
  ean: Scalars['String'];
  quantity: Scalars['Float'];
};

export type SearchRecipesResponse = {
  __typename: 'SearchRecipesResponse';
  items: Array<Recipe>;
  maybeHasMore: Scalars['Boolean'];
};

export type SearchStoresResponse = {
  __typename: 'SearchStoresResponse';
  cursor: Maybe<Scalars['String']>;
  maybeHasMore: Maybe<Scalars['Boolean']>;
  stores: Array<StoreInfo>;
  totalCount: Scalars['Int'];
};

export type SharedShoppingListLink = {
  __typename: 'SharedShoppingListLink';
  id: Scalars['String'];
};

export type ShoppingList = {
  __typename: 'ShoppingList';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  items: Array<ProductResolvedShoppingListItem | ShoppingListItem>;
  modifiedAt: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Permission>;
  shared: Scalars['Boolean'];
  storeId: Maybe<Scalars['String']>;
};

export type ShoppingListItem = IShoppingListItem & {
  __typename: 'ShoppingListItem';
  collected: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shoppingListId: Scalars['String'];
};

export type StoreAddress = {
  __typename: 'StoreAddress';
  country: Maybe<Country>;
  municipality: Municipality;
  postcode: Scalars['String'];
  postcodeName: Maybe<LocalizableText>;
  street: LocalizableText;
};

export enum StoreBrand {
  Abc = 'ABC',
  Alepa = 'ALEPA',
  Herkku = 'HERKKU',
  MestarinHerkku = 'MESTARIN_HERKKU',
  Prisma = 'PRISMA',
  Sale = 'SALE',
  SokosHerkku = 'SOKOS_HERKKU',
  SMarket = 'S_MARKET'
}

export type StoreContactInfo = {
  __typename: 'StoreContactInfo';
  email: Maybe<Scalars['String']>;
  phoneNumber: Maybe<StorePhoneNumber>;
};

export type StoreDayOpeningTime = {
  __typename: 'StoreDayOpeningTime';
  date: Scalars['String'];
  day: DayLabel;
  exceptional: Maybe<Scalars['Boolean']>;
  message: Maybe<LocalizedText>;
  mode: StoreOpeningTimeRangeLabel;
  ranges: Maybe<Array<StoreOpeningTimeRange>>;
};

export type StoreFeedback = {
  __typename: 'StoreFeedback';
  url: Maybe<LocalizableText>;
};

export type StoreInfo = {
  __typename: 'StoreInfo';
  availablePaymentMethods: Maybe<Array<PaymentMethod>>;
  brand: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  contactInfo: Maybe<StoreContactInfo>;
  distance: Maybe<Scalars['Float']>;
  domains: Array<Domain>;
  feedback: Maybe<StoreFeedback>;
  id: Scalars['ID'];
  location: Maybe<StoreLocation>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  services: Maybe<Array<StoreService>>;
  shortName: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  weeklyOpeningHours: Maybe<Array<StoreWeeklyOpeningTime>>;
};

export type StoreLocation = {
  __typename: 'StoreLocation';
  address: Maybe<StoreAddress>;
  coordinates: Maybe<Coordinates>;
};

export type StoreOpeningTimeRange = {
  __typename: 'StoreOpeningTimeRange';
  close: Scalars['String'];
  closeOnSameDay: Maybe<Scalars['Boolean']>;
  open: Scalars['String'];
};

export enum StoreOpeningTimeRangeLabel {
  AllDay = 'ALL_DAY',
  ByReservation = 'BY_RESERVATION',
  Closed = 'CLOSED',
  Range = 'RANGE'
}

export type StorePhoneNumber = {
  __typename: 'StorePhoneNumber';
  callCharge: Maybe<LocalizableText>;
  callChargeGroup: Maybe<Scalars['String']>;
  number: Scalars['String'];
};

export type StoreService = {
  __typename: 'StoreService';
  code: Scalars['String'];
  name: Maybe<LocalizableText>;
};

export type StoreWeeklyOpeningTime = {
  __typename: 'StoreWeeklyOpeningTime';
  openingTimes: Array<StoreDayOpeningTime>;
  weekNumber: Scalars['Int'];
};

export type Subscription = {
  __typename: 'Subscription';
  updatedShoppingList: Maybe<ShoppingList>;
  updatedShoppingListItem: Maybe<ProductResolvedShoppingListItem | ShoppingListItem>;
};


export type SubscriptionUpdatedShoppingListArgs = {
  id: Scalars['ID'];
};


export type SubscriptionUpdatedShoppingListItemArgs = {
  shoppingListId: Scalars['String'];
};

export type UpdateShoppingListItemInput = {
  collected?: InputMaybe<Scalars['Boolean']>;
  commentForPicker?: InputMaybe<Scalars['String']>;
  isReplaceable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename: 'User';
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  type: UserType;
};

export enum UserType {
  AnonymousUser = 'ANONYMOUS_USER'
}

export type ShoppingListItemDataFragment = (
  { __typename: 'ProductResolvedShoppingListItem' }
  & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
);

export type So_RemoteCreateUserListItemMutationVariables = Exact<{
  shoppingListId: Scalars['ID'];
  item: CreateShoppingListItemInput;
}>;


export type So_RemoteCreateUserListItemMutation = (
  { __typename: 'Mutation' }
  & { createShoppingListItem: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
  ) }
);

export type So_UpdateShoppinglistItemMutationVariables = Exact<{
  shoppingListId: Scalars['ID'];
  id: Scalars['ID'];
  item: UpdateShoppingListItemInput;
}>;


export type So_UpdateShoppinglistItemMutation = (
  { __typename: 'Mutation' }
  & { updateShoppingListItem: (
    { __typename: 'ProductResolvedShoppingListItem' }
    & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
  ) | { __typename: 'ShoppingListItem' } }
);

export type So_RemoteSetListItemsReplaceabilityMutationVariables = Exact<{
  shoppingListId: Scalars['ID'];
  isReplaceable: Scalars['Boolean'];
}>;


export type So_RemoteSetListItemsReplaceabilityMutation = (
  { __typename: 'Mutation' }
  & { setListItemsReplaceability: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
    ) | { __typename: 'ShoppingListItem' }> }
  ) }
);

export type So_RemoteRemoveShoppingListItemMutationVariables = Exact<{
  shoppingListId: Scalars['ID'];
  itemId: Scalars['ID'];
}>;


export type So_RemoteRemoveShoppingListItemMutation = (
  { __typename: 'Mutation' }
  & { deleteShoppingListItem: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
    ) | { __typename: 'ShoppingListItem' }> }
  ) }
);

export type So_RemoteAddToShoppingListMutationVariables = Exact<{
  storeId: Scalars['String'];
  shoppingListId: Scalars['ID'];
  item: CreateProductResolvedShoppingListItemInput;
}>;


export type So_RemoteAddToShoppingListMutation = (
  { __typename: 'Mutation' }
  & { createProductResolvedShoppingListItem: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'approxPrice' | 'basicQuantityUnit' | 'comparisonPrice' | 'comparisonUnit' | 'frozen' | 'isAgeLimitedByAlcohol' | 'name' | 'packagingLabelCodes' | 'price' | 'priceUnit' | 'quantityMultiplier' | 'storeId'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  ) }
);

export type ShoppingListDataFragment = (
  { __typename: 'ShoppingList' }
  & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
  & { items: Array<(
    { __typename: 'ProductResolvedShoppingListItem' }
    & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
    & { product: Maybe<(
      { __typename: 'Product' }
      & Pick<Product, 'ean' | 'id' | 'approxPrice' | 'basicQuantityUnit' | 'comparisonPrice' | 'comparisonUnit' | 'frozen' | 'isAgeLimitedByAlcohol' | 'name' | 'packagingLabelCodes' | 'price' | 'priceUnit' | 'quantityMultiplier' | 'storeId'>
      & { hierarchyPath: Maybe<Array<(
        { __typename: 'HierarchyPathItem' }
        & Pick<HierarchyPathItem, 'name'>
      )>> }
    )> }
  ) | { __typename: 'ShoppingListItem' }> }
);

export type ShoppingListFieldsFragment = (
  { __typename: 'ShoppingList' }
  & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
);

export type ListWithPartialProductDataFragment = (
  { __typename: 'ShoppingList' }
  & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
  & { items: Array<(
    { __typename: 'ProductResolvedShoppingListItem' }
    & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
    & { product: Maybe<(
      { __typename: 'Product' }
      & Pick<Product, 'ean' | 'id' | 'storeId' | 'name' | 'price'>
      & { hierarchyPath: Maybe<Array<(
        { __typename: 'HierarchyPathItem' }
        & Pick<HierarchyPathItem, 'name'>
      )>> }
    )> }
  ) | { __typename: 'ShoppingListItem' }> }
);

export type So_RemoteGetUserListsQueryVariables = Exact<{
  storeId: InputMaybe<Scalars['String']>;
}>;


export type So_RemoteGetUserListsQuery = (
  { __typename: 'Query' }
  & { shoppingLists: Array<(
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'storeId' | 'name' | 'price'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  )> }
);

export type So_UpdateShoppinglistMutationVariables = Exact<{
  shoppingListId: Scalars['ID'];
  name: InputMaybe<Scalars['String']>;
}>;


export type So_UpdateShoppinglistMutation = (
  { __typename: 'Mutation' }
  & { updateShoppingList: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
  ) }
);

export type So_RemoteGetUserListByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  storeId: InputMaybe<Scalars['String']>;
}>;


export type So_RemoteGetUserListByIdQuery = (
  { __typename: 'Query' }
  & { shoppingList: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'approxPrice' | 'basicQuantityUnit' | 'comparisonPrice' | 'comparisonUnit' | 'frozen' | 'isAgeLimitedByAlcohol' | 'name' | 'packagingLabelCodes' | 'price' | 'priceUnit' | 'quantityMultiplier' | 'storeId'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  ) }
);

export type So_RemoteCreateUserListMutationVariables = Exact<{
  name: Scalars['String'];
  storeId: Scalars['String'];
}>;


export type So_RemoteCreateUserListMutation = (
  { __typename: 'Mutation' }
  & { createShoppingList: Maybe<(
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'storeId' | 'name' | 'price'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  )> }
);

export type So_RemoteRemoveUserListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type So_RemoteRemoveUserListMutation = (
  { __typename: 'Mutation' }
  & { deleteShoppingList: (
    { __typename: 'IDObject' }
    & Pick<IdObject, 'id'>
  ) }
);

export type So_RemoteCreateUserListWithProductsMutationVariables = Exact<{
  name: Scalars['String'];
  storeId: InputMaybe<Scalars['String']>;
  items: Array<CreateProductResolvedShoppingListItemInput> | CreateProductResolvedShoppingListItemInput;
}>;


export type So_RemoteCreateUserListWithProductsMutation = (
  { __typename: 'Mutation' }
  & { createShoppingList: Maybe<(
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'storeId' | 'name' | 'price'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  )> }
);

export type So_RemoteDuplicateShoppinglistMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  storeId: Scalars['String'];
}>;


export type So_RemoteDuplicateShoppinglistMutation = (
  { __typename: 'Mutation' }
  & { duplicateShoppingList: (
    { __typename: 'ShoppingList' }
    & Pick<ShoppingList, 'id' | 'name' | 'createdAt'>
    & { items: Array<(
      { __typename: 'ProductResolvedShoppingListItem' }
      & Pick<ProductResolvedShoppingListItem, 'id' | 'sokId' | 'quantity' | 'isReplaceable' | 'commentForPicker' | 'name'>
      & { product: Maybe<(
        { __typename: 'Product' }
        & Pick<Product, 'ean' | 'id' | 'storeId' | 'name' | 'price'>
        & { hierarchyPath: Maybe<Array<(
          { __typename: 'HierarchyPathItem' }
          & Pick<HierarchyPathItem, 'name'>
        )>> }
      )> }
    ) | { __typename: 'ShoppingListItem' }> }
  ) }
);

export const ShoppingListFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<ShoppingListFieldsFragment, unknown>;
export const ShoppingListItemDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ShoppingListItemDataFragment, unknown>;
export const ShoppingListDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basicQuantityUnit"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonPrice"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonUnit"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}},{"kind":"Field","name":{"kind":"Name","value":"isAgeLimitedByAlcohol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packagingLabelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ShoppingListDataFragment, unknown>;
export const ListWithPartialProductDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListWithPartialProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ListWithPartialProductDataFragment, unknown>;
export const So_RemoteCreateUserListItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteCreateUserListItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"item"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShoppingListItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShoppingListItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shoppingListId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"item"},"value":{"kind":"Variable","name":{"kind":"Name","value":"item"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<So_RemoteCreateUserListItemMutation, So_RemoteCreateUserListItemMutationVariables>;
export const So_UpdateShoppinglistItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_UpdateShoppinglistItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"item"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShoppingListItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShoppingListItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shoppingListId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"item"},"value":{"kind":"Variable","name":{"kind":"Name","value":"item"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<So_UpdateShoppinglistItemMutation, So_UpdateShoppinglistItemMutationVariables>;
export const So_RemoteSetListItemsReplaceabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteSetListItemsReplaceability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isReplaceable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setListItemsReplaceability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shoppingListId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isReplaceable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isReplaceable"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<So_RemoteSetListItemsReplaceabilityMutation, So_RemoteSetListItemsReplaceabilityMutationVariables>;
export const So_RemoteRemoveShoppingListItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteRemoveShoppingListItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShoppingListItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shoppingListId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<So_RemoteRemoveShoppingListItemMutation, So_RemoteRemoveShoppingListItemMutationVariables>;
export const So_RemoteAddToShoppingListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteAddToShoppingList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"item"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProductResolvedShoppingListItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductResolvedShoppingListItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shoppingListId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"item"},"value":{"kind":"Variable","name":{"kind":"Name","value":"item"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basicQuantityUnit"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonPrice"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonUnit"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}},{"kind":"Field","name":{"kind":"Name","value":"isAgeLimitedByAlcohol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packagingLabelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteAddToShoppingListMutation, So_RemoteAddToShoppingListMutationVariables>;
export const So_RemoteGetUserListsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SO_RemoteGetUserLists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shoppingLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListWithPartialProductData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListWithPartialProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteGetUserListsQuery, So_RemoteGetUserListsQueryVariables>;
export const So_UpdateShoppinglistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_UpdateShoppinglist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingListId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<So_UpdateShoppinglistMutation, So_UpdateShoppinglistMutationVariables>;
export const So_RemoteGetUserListByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SO_RemoteGetUserListById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basicQuantityUnit"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonPrice"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonUnit"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}},{"kind":"Field","name":{"kind":"Name","value":"isAgeLimitedByAlcohol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packagingLabelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteGetUserListByIdQuery, So_RemoteGetUserListByIdQueryVariables>;
export const So_RemoteCreateUserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteCreateUserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListWithPartialProductData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListWithPartialProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteCreateUserListMutation, So_RemoteCreateUserListMutationVariables>;
export const So_RemoteRemoveUserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteRemoveUserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<So_RemoteRemoveUserListMutation, So_RemoteRemoveUserListMutationVariables>;
export const So_RemoteCreateUserListWithProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteCreateUserListWithProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProductResolvedShoppingListItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"productResolvedItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListWithPartialProductData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListWithPartialProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteCreateUserListWithProductsMutation, So_RemoteCreateUserListWithProductsMutationVariables>;
export const So_RemoteDuplicateShoppinglistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SO_RemoteDuplicateShoppinglist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateShoppingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListWithPartialProductData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShoppingListItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sokId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isReplaceable"}},{"kind":"Field","name":{"kind":"Name","value":"commentForPicker"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListWithPartialProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShoppingList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListFields"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductResolvedShoppingListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShoppingListItemData"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataSource"},"value":{"kind":"EnumValue","value":"S_KAUPAT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<So_RemoteDuplicateShoppinglistMutation, So_RemoteDuplicateShoppinglistMutationVariables>;